/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useState, useEffect } from "react";
import { useGLTF, Plane } from "@react-three/drei";
import { MathUtils, Box3, Vector3 } from 'three';
import { useSpring, a, config } from '@react-spring/three';

export function CSS3(props) {
    const [isHovered, setIsHovered] = useState(false);
    const currentRotation = useRef(MathUtils.degToRad(-110))
    const [planeSize, setPlaneSize] = useState([1, 1]);
    const groupRef = useRef(); // Reference to the group

    const { rotation } = useSpring({
        from: {
        rotation: currentRotation.current
        },
        config: config.wobbly
    })
    const { nodes } = useGLTF("/models/css3_model.glb");

    useEffect(() => {
        if (groupRef.current) {
            const boundingBox = new Box3().setFromObject(groupRef.current);
            const size = new Vector3();
            boundingBox.getSize(size);
            setPlaneSize([size.x + 0.5, size.y + 0.5]); // Update state with the new size
        }
    }, [props.scale]);

    useEffect(() => {
        if(isHovered){
            rotation.start({
                to: currentRotation.current + MathUtils.degToRad(40)
            })
        } else {
            rotation.start({
                to: MathUtils.degToRad(-110)
            })
        }
    }, [isHovered, rotation])

    return (
        <>
        <Plane
            args={planeSize}
            position={[props.position[0] + (0.02 * props.scale), props.position[1] + (0.4 * props.scale), props.position[2]]}
            onPointerOver={() => setIsHovered(true)}
            onPointerOut={() => setIsHovered(false)}
            visible={props.showBox}
        />
        <a.group {...props}
            dispose={null}
            ref={groupRef}
            scale={[(0.8 * props.scale), (0.5 * props.scale), (0.45 * props.scale)]}
            rotation={[0, MathUtils.degToRad(-110), 0]}
            rotation-y={rotation} 
        >
        <group
            position={[-0.183, 0.314, 0.104]}
            rotation={[1.587, 0, 0.002]}
            scale={0.011}
        >
            <group position={[20.789, -26.035, 10.172]} scale={0.01}>
            <group position={[326.27, 35.487, 1926.617]}>
                <mesh
                castShadow
                receiveShadow
                geometry={nodes.Object_7.geometry}
                // material={materials["Material.002"]}
                >
                <meshPhysicalMaterial 
                    color='blue'
                    metalness={0}
                    roughness={0.5}
                    clearcoat={0.8}
                />
                </mesh>
                <mesh
                castShadow
                receiveShadow
                geometry={nodes.Object_8.geometry}
                // material={materials["Material.003"]}
                >
                <meshPhysicalMaterial 
                    color='blue'
                    metalness={0}
                    roughness={0.2}
                    clearcoat={0.8}
                />
                </mesh>
            </group>
            <mesh
                castShadow
                receiveShadow
                geometry={nodes.Object_5.geometry}
                // material={materials["Material.005"]}
                position={[-142.941, -32.748, -5922.869]}
                rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                scale={100}
                >
                <meshPhysicalMaterial 
                    color='white'
                    metalness={0}
                    roughness={0.5}
                />
            </mesh>
            <mesh
                castShadow
                receiveShadow
                geometry={nodes.Object_10.geometry}
                // material={materials["Material.001"]}
                position={[-182.684, 35.487, 1926.617]}
                >
                <meshPhysicalMaterial 
                    color='blue'
                    metalness={0}
                    roughness={0.2}
                    clearcoat={0.8}
                />
            </mesh>
            </group>
        </group>
        </a.group>

    </>
  );
}

useGLTF.preload("/models/css3_model.glb");